import React from 'react';
import Support from 'assets/support.png';
import { FormattedMessage } from 'react-intl';
import { Stack } from 'react-bootstrap';

const PartnerSupport = () => {
  return (
    <>
      <img src={Support} alt="Support" width="240px" height="200px" />
      <Stack>
        <span><FormattedMessage id="login.support.text" /></span>
        <span><FormattedMessage id="login.support.phone" /></span>
        <span><FormattedMessage id="login.support.hours" /></span>
      </Stack>
    </>
  );
};

export default PartnerSupport;
